export const LANGUAGE_MAP = {
  'en-US': 'English',
  'hi-IN': 'हिंदी',
  'pt-BR': 'Português',
  'es-MX': 'Español',
  'ur-PK': 'Urdu',
};

export const LANGUAGE_TRACK_MAP = {
  'en-US': 'English',
  'hi-IN': 'Hindi',
  'pt-BR': 'Português',
  'es-MX': 'Español',
  'ur-PK': 'Urdu',
};